<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="SANS-B">Acknowledgments</span></span></p>
<p class="FMTNI-1">I want to thank my wife, Meagan Brockway, for her love and support. My dad and my grandpa, for never feeling the appropriate amount of shame over what I chose to do with their namesake. My agent, Sam Morgan, and all the folks at JABberwocky Literary Agency, Inc., for being frighteningly good at everything they do. Never cross them. My editor, Paul Stevens, for understanding and refining the manic ramblings you’re about to read, and all the fine people at Tor, for knitting it together into this beautiful, lethal little package. I want to thank Will Staehle for that cover image that makes me go weak at the knees. Thank you to all the beta readers who read this book back when it was all doodles of Voltron doing keg stands and self-portraits of me as a Ninja Turtle. I want to thank my dogs, Detectives Martin Riggs and Roger Murtaugh, for their stupid faces. And finally, thank you to all of the people who are about to read this, love the hell out of it, and send me all of their money in a fit of lustful gratitude. It is completely expected, of course, but no less appreciated.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?8bdb3e86